import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { isNilOrEmpty, isNilOrEmptyString } from 'ramda-extension';

import { generateRemainingHoursColor } from 'features/views/marketPlace/utils';

export const RemainingTimeBarMui = ({ remainingTimeData, width = '50px', height = 5, fontSize = 10 }) => {
	const { totalHours, remainingHours, statusId, finishTypeId, sla, isFromMarket } = remainingTimeData;

	if (isNilOrEmpty(totalHours) || isNilOrEmpty(remainingHours)) {
		return null;
	}

	const remainingHoursOrZero = remainingHours < 0 ? 0 : remainingHours;
	const remainingHoursColor = generateRemainingHoursColor({ totalHours, remainingHours: remainingHoursOrZero });

	const passedPeriod = totalHours - remainingHoursOrZero;
	const passedPercentageValue = (passedPeriod / totalHours) * 100;

	const hasInProgressFeedback = statusId !== 3 && !isNilOrEmptyString(finishTypeId);

	const isInTimeRange = remainingHours >= 0;

	const expirationWithSla = isFromMarket && !isNilOrEmptyString(sla) && isNilOrEmptyString(finishTypeId);
	const expirationWithoutSla = !isFromMarket || isNilOrEmptyString(sla);

	const showExpirationWithSlaCond = expirationWithSla && isInTimeRange;
	const showExpiration = expirationWithoutSla && isInTimeRange && isNilOrEmptyString(finishTypeId);

	return (
		(hasInProgressFeedback || showExpirationWithSlaCond || showExpiration) && (
			<Stack
				direction="row"
				spacing={1}
				sx={{
					alignItems: 'center',
				}}
			>
				<Box sx={{ width }}>
					<LinearProgress
						sx={{
							height,
							borderRadius: 5,
							[`&.${linearProgressClasses.colorPrimary}`]: {
								backgroundColor: remainingHoursColor,
							},
							[`& .${linearProgressClasses.bar}`]: {
								backgroundColor: (theme) => theme.palette.grey[300],
							},
						}}
						variant="determinate"
						value={passedPercentageValue}
					/>
				</Box>
				<Typography
					variant="caption"
					sx={{
						fontSize,
					}}
				>
					{remainingHoursOrZero}h
				</Typography>
			</Stack>
		)
	);
};

RemainingTimeBarMui.propTypes = {
	fontSize: PropTypes.number,
	height: PropTypes.number,
	remainingTimeData: PropTypes.shape({
		finishTypeId: PropTypes.number,
		isFromMarket: PropTypes.bool,
		statusId: PropTypes.number,
		totalHours: PropTypes.number,
		remainingHours: PropTypes.number,
		sla: PropTypes.number,
	}),
	width: PropTypes.string,
};

export default RemainingTimeBarMui;
